<template>
  <div class="movement-detail-page">
    <!-- Barra superior con acciones y estado -->
    <v-card class="mb-4 elevation-2">
      <v-app-bar flat dense color="primary" dark>
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Detalles del Proceso</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-chip v-if="!loading" small :color="estadoProceso.estadoProceso.button_color" :text-color="estadoProceso.estadoProceso.text_color" class="font-weight-medium">
          <v-icon left x-small>{{ getStatusIcon(estadoProceso.estadoProceso) }}</v-icon>
          {{ estadoProceso.estadoProceso.name }}
        </v-chip>

        <v-btn v-if="!loading && canChangeStatus()" small outlined color="white" class="ml-2" @click="acceptVehicleLocationEstadoProceso">
          <v-icon left small>mdi-arrow-up-bold</v-icon>
          Avanzar estado
        </v-btn>
      </v-app-bar>
    </v-card>

    <!-- Contenido principal -->
    <v-container>
      <!-- Estado de carga -->
      <div v-if="loading" class="text-center py-8">
        <v-progress-circular indeterminate color="primary" size="50" width="5"></v-progress-circular>
        <div class="mt-4 text-subtitle-1 font-weight-medium grey--text text--darken-1">
          Cargando detalles del estadoProceso...
        </div>
      </div>

      <template v-else>
        <!-- Información del estadoProceso -->
        <v-card class="mb-4 elevation-1">
          <v-card-title class="d-flex align-center pb-1">
            <v-avatar color="primary lighten-4" size="42" class="mr-3">
              <v-icon color="primary">mdi-car</v-icon>
            </v-avatar>
            <div>              
              <div class="text-h5 font-weight-medium">
                {{ (estadoProceso.vehicle.brand || 'Sin marca') }} {{ (estadoProceso.vehicle.model || 'Sin modelo') }}
              </div>
              <div class="caption grey--text d-flex align-center">
                <v-icon x-small class="mr-1">mdi-calendar</v-icon>
                {{ estadoProceso.created_at ? formatDateHours(estadoProceso.created_at) : formatDateHours(estadoProceso.created_at) }}
                <v-icon x-small class="mx-1">mdi-circle-small</v-icon>
                {{ estadoProceso.estadoProceso.name }}
              </div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-divider></v-divider>

          <!-- Trayecto (origen-destino) -->
          <v-card-text class="py-2">
            <div class="d-flex align-center">
              <v-icon color="primary" class="mr-2">mdi-map-marker-path</v-icon>              <div class="text-body-1">
                <span class="font-weight-medium grey--text text--darken-1">{{ estadoProceso.lastEstadoProceso ? estadoProceso.lastEstadoProceso.name : 'Sin Estado' }}</span>
                <v-icon small class="mx-1">mdi-arrow-right</v-icon>
                <span class="font-weight-medium">{{ estadoProceso.estadoProceso ? estadoProceso.estadoProceso.name : 'Sin Estado' }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- Pestañas para organizar la información -->
        <v-card class="elevation-1">
          <v-tabs v-model="activeTab" background-color="transparent" grow>
            <v-tab>
              <v-icon left>mdi-information-outline</v-icon>
              Detalles
            </v-tab>
            <v-tab>
              <v-icon left>mdi-car-info</v-icon>
              Vehículo
            </v-tab>
            <v-tab>
              <v-icon left>mdi-image-multiple</v-icon>
              Imágenes
              <v-badge v-if="allImages && allImages.length" color="primary"
                :content="allImages.length" offset-x="10" offset-y="-4" small></v-badge>
            </v-tab>
            <v-tab>
              <v-icon left>mdi-file-document-multiple</v-icon>
              Documentos
              <v-badge v-if="documentFiles && documentFiles.length" color="primary"
                :content="documentFiles.length" offset-x="10" offset-y="-4" small></v-badge>
            </v-tab>
          </v-tabs>

          <v-divider></v-divider>

          <!-- Contenido de pestañas -->
          <v-tabs-items v-model="activeTab">
            <!-- Pestaña de detalles del estadoProceso -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <!-- Columna izquierda -->
                    <v-col cols="12" md="6">
                      <v-simple-table dense>
                        <tbody>
                          <tr>
                            <td class="font-weight-medium" width="40%">
                              <v-icon small color="primary" class="mr-1">mdi-swap-horizontal-bold</v-icon>
                              Tipo
                            </td>                            
                            <td>
                              {{ 'Proceso' }}
                            </td>
                          </tr>
                          <tr>
                            <td class="font-weight-medium">
                              <v-icon small color="primary" class="mr-1">mdi-account-tie</v-icon>
                              Responsable
                            </td>
                            <td>
                              <template v-if="estadoProceso.responsable">
                                {{ estadoProceso.responsable.name }} {{ estadoProceso.responsable.lastname }}
                                </template>
                                <template v-else>
                                No especificado
                                </template>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>

                    <!-- Columna derecha -->
                    <v-col cols="12" md="6">
                      <v-simple-table dense>
                        <tbody>
                          <tr>
                            <td class="font-weight-medium">
                              <v-icon small color="primary" class="mr-1">mdi-account-edit</v-icon>
                              Fecha
                            </td>                            
                            <td>
                              {{ formatDate(estadoProceso.created_at) }}
                            </td>
                          </tr>
                          <tr>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>

                  <!-- Información adicional -->
                  <div v-if="estadoProceso.additional_info" class="mt-4">
                    <v-divider class="mb-3"></v-divider>
                    <div class="font-weight-medium mb-2">
                      <v-icon small color="primary" class="mr-1">mdi-information-outline</v-icon>
                      Información adicional
                    </div>
                    <div class="body-2 pa-2 blue lighten-5 rounded preserve-linebreaks">
                      {{ estadoProceso.additional_info }}
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Pestaña de información del vehículo -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-simple-table dense>
                        <tbody>
                          <tr>
                            <td class="font-weight-medium" width="35%">
                              <v-icon small color="primary" class="mr-1">mdi-tag</v-icon>
                              Marca
                            </td>
                            <td>{{ estadoProceso.vehicle.brand || 'No especificado' }}</td>
                          </tr>
                          <tr>
                            <td class="font-weight-medium">
                              <v-icon small color="primary" class="mr-1">mdi-car-side</v-icon>
                              Modelo
                            </td>
                            <td>{{ estadoProceso.vehicle.model || 'No especificado' }}</td>
                          </tr>
                          <tr>
                            <td class="font-weight-medium">
                              <v-icon small color="primary" class="mr-1">mdi-card-bulleted</v-icon>
                              Matrícula
                            </td>
                            <td>{{ estadoProceso.vehicle.plate_number || 'No especificado' }}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-simple-table dense>
                        <tbody>
                          <tr>
                            <td class="font-weight-medium" width="35%">
                              <v-icon small color="primary" class="mr-1">mdi-card-account-details</v-icon>
                              Número IIC
                            </td>
                            <td>{{ estadoProceso.vehicle.iic_number || 'No especificado' }}</td>
                          </tr>
                          <tr>
                            <td class="font-weight-medium">
                              <v-icon small color="primary" class="mr-1">mdi-identifier</v-icon>
                              Bastidor
                            </td>
                            <td>{{ estadoProceso.vehicle.frame_number || 'No especificado' }}</td>
                          </tr>
                          <tr>
                            <td class="font-weight-medium">
                              <v-icon small color="primary" class="mr-1">mdi-car-info</v-icon>
                              Ver ficha completa
                            </td>
                            <td>
                              <v-btn x-small outlined color="primary"
                                :to="{ name: 'VehiculoDetail', params: { id: estadoProceso.vehicle.id } }">
                                Ver vehículo
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Pestaña de imágenes -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <!-- Imágenes de daños y adicionales combinadas -->
                  <div v-if="allImages && allImages.length > 0">
                    <v-row>
                      <!-- Imágenes de daños -->
                      <v-col v-for="(image, i) in estadoProceso.imagesUrls" :key="`damage-${i}`" cols="12" sm="6" md="4" lg="3">
                        <v-card class="mx-auto image-card" outlined hover>
                          <v-img :src="image.url" height="150" cover class="cursor-pointer" @click="openImageDialog(image.url)">
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                              </v-row>
                            </template>
                            <div class="image-overlay d-flex align-center justify-center">
                              <v-icon color="white">mdi-magnify-plus</v-icon>
                            </div>
                          </v-img>
                          <!-- Chip para imágenes de daños según type -->
                          <!-- <v-chip class="image-badge" x-small color="error" text-color="white">
                            <v-icon left x-small>
                              {{ image.type === 'entrega' ? 'mdi-arrow-up-bold' : 'mdi-arrow-down-bold' }}
                            </v-icon>
                            {{ image.type === 'entrega' ? 'Entrega' : image.type === 'recepcion' ? 'Recepción' : 'Daño' }}
                          </v-chip> -->
                          <!-- Botón de descarga -->
                          <v-btn 
                            class="download-button" 
                            icon 
                            x-small 
                            color="white"
                            @click.stop="downloadImage(image.url, `imagen_${i + 1}`)"
                          >
                            <v-icon small>mdi-download</v-icon>
                          </v-btn>
                        </v-card>
                      </v-col>
                      
                      <!-- Imágenes adicionales -->
                      <v-col v-for="(image, i) in additionalImagesArray" :key="`additional-${i}`" cols="12" sm="6" md="4" lg="3">
                        <v-card class="mx-auto image-card" outlined hover>
                          <v-img :src="image.url" height="150" cover class="cursor-pointer" @click="openImageDialog(image.url)">
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                              </v-row>
                            </template>
                            <div class="image-overlay d-flex align-center justify-center">
                              <v-icon color="white">mdi-magnify-plus</v-icon>
                            </div>
                          </v-img>
                          <!-- Chip para imágenes adicionales según type -->
                          <v-chip class="image-badge" x-small color="success" text-color="white">
                            <v-icon left x-small>
                              {{ image.type === 'entrega' ? 'mdi-arrow-up-bold' : 'mdi-arrow-down-bold' }}
                            </v-icon>
                            {{ image.type === 'entrega' ? 'Entrega' : image.type === 'recepcion' ? 'Recepción' : 'Adicional' }}
                          </v-chip>
                          <!-- Botón de descarga -->
                          <v-btn 
                            class="download-button" 
                            icon 
                            x-small 
                            color="white"
                            @click.stop="downloadImage(image.url, `adicional_${i + 1}`)"
                          >
                            <v-icon small>mdi-download</v-icon>
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else class="text-center py-8 grey--text">
                    <v-icon size="50" color="grey lighten-2">mdi-image-off</v-icon>
                    <div class="mt-2">No hay imágenes disponibles</div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Pestaña de documentos -->
            <v-tab-item>
              <v-card flat>
                <v-card-text>
                  <!-- Documentos -->
                  <div v-if="documentFiles && documentFiles.length > 0">
                    <v-list>
                      <v-list-item v-for="(doc, i) in documentFiles" :key="`doc-${i}`" class="document-item">
                        <v-list-item-avatar>
                          <v-icon :color="getFileIconColor(doc.filename || doc.name)" size="32">{{ getFileIcon(doc.filename || doc.name) }}</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">{{ doc.filename || doc.name || getFileName(doc.url) }}</v-list-item-title>
                          <v-list-item-subtitle>
                            <v-chip x-small color="primary" text-color="white" class="mr-2">
                              <v-icon left x-small>mdi-file-document</v-icon>
                              Documento del proceso
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon color="primary" @click="downloadDocument(doc.url, doc.filename || doc.name || getFileName(doc.url))">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>
                  <div v-else class="text-center py-8 grey--text">
                    <v-icon size="50" color="grey lighten-2">mdi-file-document-off</v-icon>
                    <div class="mt-2">No hay documentos disponibles</div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import VehicleLocationEstadoProcesoService from '@/services/EstadoProcesoService'
// import UserService from '@/services/UserService'
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'

export default {
  components: {

  },

  data () {
    return {
      loading: true,
      estadoProceso: null,
      creado: null,
      update: null,
      crane: null,
      visibleVehicleLocationEstadoProcesoForm: false,
      editItem: null,
      deleteDialog: false,
      imageViewerVisible: false,
      currentImageIndex: 0,
      activeTab: 0,
      moment: moment
    }
  },

  async created () {
    await this.loadVehicleLocationEstadoProcesoDetails()
  },

  methods: {
    async loadVehicleLocationEstadoProcesoDetails () {
      try {
        this.loading = true
        const moviId = this.$route.params.proceso_id
        const { data } = await VehicleLocationEstadoProcesoService.viewVehicleLocationEstadoProceso({ id: moviId })
        this.estadoProceso = data.data

        // Cargar datos de usuarios
      //   const creadoData = await UserService.view({ id: this.estadoProceso.created_by })
      //   this.creado = creadoData.data
      //   if (this.estadoProceso.crane_id) {
      //     const grua = await GruaService.view({ id: this.estadoProceso.crane_id })
      //     this.crane = grua.data.data
      //   }
        
      //   const updateData = await UserService.view({ id: this.estadoProceso.updated_by })
      //   this.update = updateData.data
      } catch (error) {
        console.error('Error al cargar los detalles del estadoProceso:', error)
        this.$toast.error('Error al cargar los detalles del estadoProceso')
      } finally {
        this.loading = false
      }
    },

    showVehicleLocationEstadoProcesoForm (item) {
      this.editItem = item
      this.visibleVehicleLocationEstadoProcesoForm = true
    },

    saveVehicleLocationEstadoProceso () {
      this.visibleVehicleLocationEstadoProcesoForm = false
      this.loadVehicleLocationEstadoProcesoDetails()
      this.$toast.success('VehicleLocationEstadoProceso actualizado con éxito')
    },

    confirmDeleteVehicleLocationEstadoProceso () {
      this.deleteDialog = true
    },

    async deleteVehicleLocationEstadoProceso  () {
      try {
        this.deleteDialog = false
        const moviId = this.$route.params.estadoProceso_id
        await VehicleLocationEstadoProcesoService.delete({ id: moviId }).then((response) => {
          if (response.error) {
            this.$toast.error('Error al eliminar el estadoProceso')
            return
          }
          this.$toast.success('VehicleLocationEstadoProceso eliminado con éxito')
          this.$router.push({ name: 'VehicleLocationEstadoProceso' })
        })
      } catch (error) {
        console.error('Error al eliminar el estadoProceso:', error)
        this.$toast.error('Error al eliminar el estadoProceso')
      }
    },

    async acceptVehicleLocationEstadoProceso () {
      try {
        const moviId = this.$route.params.estadoProceso_id
        let newStatus = 'reported'

        await VehicleLocationEstadoProcesoService.changeStatus(moviId, { status: newStatus }).then((response) => {
          if (response.error) {
            this.$toast.error('Ocurrió un error al cambiar el estado del estadoProceso')
            return
          }
          this.$toast.success('Estado del estadoProceso actualizado con éxito')
          this.loadVehicleLocationEstadoProcesoDetails()
        })
      } catch (error) {
        console.error('Error al cambiar el estado del estadoProceso:', error)
        this.$toast.error('Ocurrió un error al cambiar el estado del estadoProceso')
      }
    },

    getCurrentUserRoles () {
      return this.$store.getters.CURRENT_USER_ROLES || []
    },

    canChangeStatus () {
      if (!this.estadoProceso) return false
      if (this.estadoProceso.status !== 'unreported') return false
      // El colaborador no puede cambiar el estado
      if (this.getCurrentUserRoles().includes('colaborator')) return false
      return true
    },

    formatDate (timestamp) {
      if (!timestamp) return 'N/A'
      return moment.unix(timestamp).tz('Europe/Madrid').format('DD/MM/YYYY HH:mm')
    },

    formatDateHours (timestamp) {
      if (!timestamp) return 'N/A'
      return moment.unix(timestamp).tz('Europe/Madrid').format('DD/MM/YYYY HH:mm')
    },

    translateStatus (status) {
      const statusMap = {
        'unreported': 'No reportado',
        'reported': 'Reportado',
        'transport': 'Recepcionado',
        'processing': 'En proceso',
        'completed': 'Completado'
      }
      return statusMap[status] || status
    },

    getStatusColor (status) {
      const statusColorMap = {
        'unreported': 'red',
        'reported': 'orange',
        'transport': 'blue',
        'processing': 'purple',
        'completed': 'green'
      }
      return statusColorMap[status] || 'grey'
    },

    getStatusIcon (status) {
      const statusIconMap = {
        'unreported': 'mdi-alert-circle-outline',
        'reported': 'mdi-bell-ring-outline',
        'transport': 'mdi-truck-outline',
        'processing': 'mdi-progress-clock',
        'completed': 'mdi-check-circle-outline'
      }
      return statusIconMap[status] || 'mdi-help-circle-outline'
    },

    openImageViewer (index) {
      this.currentImageIndex = index
      this.imageViewerVisible = true
    },

    openImageDialog (imageUrl) {
      // Encontrar el índice de la imagen en el array combinado
      const index = this.allImages.findIndex(img => img.url === imageUrl)
      if (index !== -1) {
        this.currentImageIndex = index
        this.imageViewerVisible = true
      }
    },

    async downloadImage (imageUrl, defaultName) {
      try {
        // Fetch la imagen como blob
        const response = await fetch(imageUrl)
        const blob = await response.blob()
        
        // Crear URL temporal del blob
        const blobUrl = window.URL.createObjectURL(blob)
        
        // Extraer extensión de la URL o usar jpg por defecto
        const extension = imageUrl.split('.').pop().split('?')[0] || 'jpg'
        const fileName = `${defaultName}_${Date.now()}.${extension}`
        
        // Crear elemento temporal de descarga
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        
        // Limpiar
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
        
        this.$toast.success('Imagen descargada correctamente')
      } catch (error) {
        console.error('Error al descargar la imagen:', error)
        this.$toast.error('Error al descargar la imagen')
      }
    },

    async downloadDocument (docUrl, fileName) {
      try {
        // Intentar descargar con fetch primero
        try {
          const response = await fetch(docUrl, {
            mode: 'cors',
            credentials: 'include'
          })
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          
          const blob = await response.blob()
          const blobUrl = window.URL.createObjectURL(blob)
          
          const link = document.createElement('a')
          link.href = blobUrl
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          
          document.body.removeChild(link)
          window.URL.revokeObjectURL(blobUrl)
          
          this.$toast.success('Documento descargado correctamente')
        } catch (fetchError) {
          // Si fetch falla (por CORS u otro motivo), abrir en nueva pestaña
          console.warn('Fetch falló, abriendo en nueva pestaña:', fetchError)
          const link = document.createElement('a')
          link.href = docUrl
          link.target = '_blank'
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          
          this.$toast.success('Documento abierto en nueva pestaña')
        }
      } catch (error) {
        console.error('Error al descargar el documento:', error)
        this.$toast.error('Error al descargar el documento')
      }
    },

    getFileName (url) {
      if (!url) return 'documento'
      const parts = url.split('/')
      const fileName = parts[parts.length - 1]
      return fileName.split('?')[0] || 'documento'
    },

    getFileIcon (fileData) {
      // Soporta tanto extension directa como URL
      const extension = typeof fileData === 'string' 
        ? fileData.split('.').pop().toLowerCase().split('?')[0]
        : fileData
      
      const iconMap = {
        pdf: 'mdi-file-pdf-box',
        doc: 'mdi-file-word-box',
        docx: 'mdi-file-word-box',
        xls: 'mdi-file-excel-box',
        xlsx: 'mdi-file-excel-box',
        txt: 'mdi-file-document-outline',
        zip: 'mdi-folder-zip',
        rar: 'mdi-folder-zip'
      }
      return iconMap[extension] || 'mdi-file-outline'
    },

    getFileIconColor (fileData) {
      // Soporta tanto extension directa como URL
      const extension = typeof fileData === 'string'
        ? fileData.split('.').pop().toLowerCase().split('?')[0]
        : fileData
      
      const colorMap = {
        pdf: 'red',
        doc: 'blue',
        docx: 'blue',
        xls: 'green',
        xlsx: 'green',
        txt: 'grey',
        zip: 'orange',
        rar: 'orange'
      }
      return colorMap[extension] || 'grey'
    }
  },

  computed: {
    allImages () {
      const images = []
      
      // Agregar imágenes de daños
      if (this.estadoProceso && this.estadoProceso.imagesUrls) {
        this.estadoProceso.imagesUrls.forEach(img => {
          images.push({
            ...img,
            type: 'damage'
          })
        })
      }
      
      // Agregar imágenes adicionales
      if (this.estadoProceso && this.estadoProceso.additionalImagesUrls) {
        // Verificar si es un array o un objeto
        if (Array.isArray(this.estadoProceso.additionalImagesUrls)) {
          // Si es un array, usar forEach normalmente
          this.estadoProceso.additionalImagesUrls.forEach(img => {
            images.push({
              ...img,
              type: 'additional'
            })
          })
        } else {
          // Si es un objeto, convertir a array usando Object.values()
          Object.values(this.estadoProceso.additionalImagesUrls).forEach(img => {
            images.push({
              ...img,
              type: 'additional'
            })
          })
        }
      }
      
      return images
    },
    additionalImagesArray () {
      if (!this.estadoProceso || !this.estadoProceso.additionalImagesUrls) {
        return []
      }
      
      // Verificar si es un array o un objeto
      if (Array.isArray(this.estadoProceso.additionalImagesUrls)) {
        return this.estadoProceso.additionalImagesUrls
      } else {
        // Si es un objeto, convertir a array usando Object.values()
        return Object.values(this.estadoProceso.additionalImagesUrls)
      }
    },

    // Obtener documentos del proceso
    documentFiles () {
      if (!this.estadoProceso || !this.estadoProceso.estadoProceso || !this.estadoProceso.estadoProceso.additionalDocsUrls) {
        return []
      }
      
      const docsArray = Array.isArray(this.estadoProceso.estadoProceso.additionalDocsUrls)
        ? this.estadoProceso.estadoProceso.additionalDocsUrls
        : Object.values(this.estadoProceso.estadoProceso.additionalDocsUrls || {})
      
      return docsArray.filter(doc => doc && doc.url)
    },

    ...mapGetters(['HAS_PERMISSION']),

    canEditVehicleLocationEstadoProceso() {
      return this.HAS_PERMISSION('editar_estadoProceso')
    },

    canDeleteVehicleLocationEstadoProceso() {
      return this.HAS_PERMISSION('eliminar_estadoProceso')
    }
  }
}
</script>

<style scoped>
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-badge {
  position: absolute !important;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.download-button {
  position: absolute !important;
  bottom: 8px;
  right: 8px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.6) !important;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.image-card:hover .download-button {
  opacity: 1;
}

.v-img:hover .image-overlay {
  opacity: 1;
}

.cursor-pointer {
  cursor: pointer;
}

.image-viewer {
  background-color: rgba(0, 0, 0, 0.95);
}

.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
}

.v-data-table td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.preserve-linebreaks {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.document-item {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.3s ease;
}

.document-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.document-item:last-child {
  border-bottom: none;
}
</style>
